import { render, staticRenderFns } from "./PublicAlbumContent.vue?vue&type=template&id=d36c825e&scoped=true&"
import script from "./PublicAlbumContent.vue?vue&type=script&lang=js&"
export * from "./PublicAlbumContent.vue?vue&type=script&lang=js&"
import style0 from "./PublicAlbumContent.vue?vue&type=style&index=0&id=d36c825e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36c825e",
  null
  
)

export default component.exports